<template>
	<div>
		<FullModal :title="'Check In'" ref="modalEventCheckIn" @back="close">
			<div class="content">
				<Loader :show="loading" />

				<div class="qr-readed" v-if="showReader">
					<StreamBarcodeReader @decode="codeReaded" @loaded="onInit" ref="rootElement"></StreamBarcodeReader>
				</div>

				<div
					class="scan-result animated fadeInDown faster"
					v-if="readResult"
					:class="readResult.canCheckIn ? 'success' : 'fail'"
				>
					<div class="head">
						<div class="label">EVENTO</div>
						<h2>{{ readResult.event.name }}</h2>
						<div class="day">{{ readResult.event.startAt | moment("dddd DD [de] MMMM YYYY ") }}</div>
						<div class="hour">{{ readResult.event.startAt | moment("HH:mm") }}</div>
					</div>

					<div class="separator"></div>

					<div class="data">
						<div class="status" v-if="readResult.canCheckIn">
							<i class="icon icon-android-checkmark-circle" />
							Ingreso habilitado
						</div>
						<div class="status" v-if="!readResult.canCheckIn">
							<i class="icon icon-android-close" />
							Ingreso inhabilitado
							<p v-if="readResult.message" class="mt-2 px-3" style="font-size:13px">
								{{ readResult.message }}
							</p>
						</div>

						<div class="client-data mt-3 text-center" v-if="readResult.client">
							<h4>{{ readResult.client.name }} {{ readResult.client.lastname }}</h4>
							<h5>CI: {{ readResult.client.document }}</h5>
						</div>
						<div class="client-data mt-2 text-center" v-if="readResult.ticket">
							<h5 class="mt-2">{{ readResult.ticket.ticketType.name }}</h5>
							<p>{{ readResult.ticket.ticketType.ticketGroup.name }}</p>
						</div>
					</div>

					<div class="separator"></div>

					<div class="p-4 buttons">
						<div class="btn btn-light mt-2 px-5" v-ripple @click="checkIn" v-if="readResult.canCheckIn">
							REGISTRAR INGRESO
						</div>
						<div class="btn btn-link mt-2" v-ripple @click="close">
							Cerrar
						</div>
					</div>
				</div>
			</div>
		</FullModal>
	</div>
</template>

<script>
import gql from "graphql-tag"
import FullModal from "@/components/FullModal"
import { StreamBarcodeReader } from "vue-barcode-reader"

export default {
	name: "EquipmentDetailModal",
	components: {
		FullModal,
		StreamBarcodeReader
	},
	props: {
		event: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			loading: true,
			saving: false,
			showReader: true,
			beep: new Audio(require("@/assets/beep.mp3")),
			readResult: null
		}
	},

	methods: {
		async open() {
			this.showReader = true
			this.loading = true
			this.$refs.modalEventCheckIn.open()
		},
		close() {
			this.$refs.modalEventCheckIn.close()
			this.readResult = null
			this.showReader = false
		},

		codeReaded(data) {
			this.beep.play()
			if (data) {
				this.showReader = false
				this.checkAccessCode(data)
			} else {
				this.$toast.error("Error al leer el código")
				return false
			}
		},
		async onInit(promise) {
			try {
				await promise
				console.log("asdasd")
				this.loading = false
			} catch (error) {
				console.log(error)
			}
		},

		checkAccessCode(code) {
			this.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($eventId: ID!, $code: String!) {
							eventCodeCanCheckIn(eventId: $eventId, code: $code) {
								event {
									id
									name
									startAt
								}
								ticket {
									id
									ticketType {
										id
										name
										ticketGroup {
											id
											name
										}
									}
								}
								membership {
									id
								}
								client {
									id
									name
									lastname
									document
								}
								canCheckIn
								message
							}
						}
					`,
					variables: {
						eventId: this.event.id,
						code
					}
				})
				.then(({ data }) => {
					this.readResult = data.eventCodeCanCheckIn
					this.loading = false
				})
				.catch((error) => {
					console.log(error)
					this.loading = false
				})
		},

		checkIn() {
			this.loading = true

			if (!this.readResult) return

			const entranceType = this.readResult.ticket ? "ticket" : this.readResult.membership ? "membership" : false
			if (!entranceType) return

			this.$apollo
				.mutate({
					mutation: gql`
						mutation($eventId: ID!, $ticketId: ID, $membershipId: ID) {
							eventCheckIn(eventId: $eventId, ticketId: $ticketId, membershipId: $membershipId)
						}
					`,
					variables: {
						eventId: this.event.id,
						ticketId: this.readResult.ticket ? this.readResult.ticket.id : null,
						membershipId: this.readResult.membership ? this.readResult.membership.id : null
					}
				})
				.then(({ data }) => {
					this.close()
					this.loading = false
				})
				.catch((error) => {
					console.log(error)
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.qr-readed {
	// width: 100%;
	display: flex;
	flex-grow: 1;
	align-items: center;
	height: calc(100vh - 80px);

	.scanner-container {
		// height: 100%;
	}
}
.scan-result {
	width: calc(100% - 24px);
	height: calc(100% - 24px);
	position: fixed;
	top: 12px;
	left: 12px;
	border-radius: 8px;
	color: #fff;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	z-index: 1200;

	&.success {
		background-color: #10c6b7;
	}
	&.fail {
		background-color: #e73d3d;
	}

	.head {
		width: 100%;
		padding: 18px;

		h2 {
			font-size: 1.8rem;
		}
	}

	.separator {
		width: 100%;
		border-bottom: 5px dotted #252525;
		position: relative;

		&:after {
			position: absolute;
			width: 18px;
			height: 18px;
			background-color: #252525;
			content: "";
			border-radius: 9px;
			bottom: -11px;
			right: -9px;
		}
		&:before {
			position: absolute;
			width: 18px;
			height: 18px;
			background-color: #252525;
			content: "";
			border-radius: 9px;
			bottom: -11px;
			left: -9px;
		}
	}

	.data {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		flex-grow: 1;
	}

	.client-data {
		h4 {
			font-size: 1.3rem;
		}
		h5 {
			font-size: 1rem;
		}
	}

	.status {
		font-size: 1.2rem;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.icon {
			font-size: 5rem;
			width: 90px;
			height: 90px;
		}
	}
}
</style>
